import { keepPreviousData } from '@tanstack/query-core'
import queryString from 'query-string'
import {
  PricingPlanResponse,
  PricingPlansParams,
} from 'src/queries/organizations/pricingPlans/pricingPlans.types'
import { pricingPlansQueryKeys } from 'src/queries/queries.constants'
import {
  CustomQueryOptions,
  RequestConfig,
  useExtendQuery,
} from 'src/queries/queries.utils'

export function useQueryPricingPlans(
  organizationId?: string,
  options?: CustomQueryOptions<PricingPlanResponse>,
  params?: PricingPlansParams,
) {
  // Strip falsy fields before both the URL and the query key so
  // `{ skipRedirect: false }` (PricingPage) and no-params
  // (UpgradeSubscription) share the same cache entry for the same URL.
  const normalizedParams: PricingPlansParams = {}
  if (params?.issuerId) normalizedParams.issuerId = params.issuerId
  if (params?.skipRedirect) normalizedParams.skipRedirect = true

  const qs = queryString.stringify(normalizedParams)

  return useExtendQuery({
    queryKey: pricingPlansQueryKeys.list(organizationId, normalizedParams),
    queryUrl: () => `/saas/${organizationId}/plans${qs ? `?${qs}` : ''}`,
    ...options,
    enabled: !!organizationId && options?.enabled,
  })
}

export function useQueryPricingPlansLookup(
  bin: string,
  options?: CustomQueryOptions<PricingPlanResponse>,
) {
  return useExtendQuery({
    queryKey: pricingPlansQueryKeys.lookup(bin),
    queryUrl: () => `/saas/plans/lookup?bin=${bin}`,
    requestConfig: RequestConfig.Unauthed,
    // Keep the previous lookup result mounted while a new BIN lookup is in flight.
    placeholderData: keepPreviousData,
    retry: false,
    ...options,
    enabled: !!bin && (options?.enabled ?? true),
  })
}
